import React, { useState, useContext, useRef, useEffect } from 'react';
import { NavigationSidebarContext } from '../../contexts/navigationSidebar';
import { AuthContext } from '../../contexts/auth';
import { Bars4Icon, ArrowPathIcon, ArrowLeftStartOnRectangleIcon, UserIcon } from '@heroicons/react/24/outline'
import { UNSAFE_DataRouterStateContext, useNavigate } from 'react-router-dom';
import { Toaster, toast } from "sonner";
import { useTranslation } from "react-i18next";


function Header() {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { token, setToken, setUser, user } = useContext(AuthContext);
    const { isNavigationSidebarOpen, setNavigationSidebarOpen } = useContext(NavigationSidebarContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loadStationNameTitle, setLoadStationNameTitle] = useState(true);
    const [loadRoleNameTitle, setLoadRoleNameTitle] = useState(true);
    const [stationName, setStationName] = useState(null);
    const menuRef = useRef();
    const { t, i18n } = useTranslation();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [image, setImage] = useState(null)
    const [roleName, setRoleName] = useState(null)

    // //console.log(i18n.language);

    useEffect(() => {
        if (user.stations[0]) {
            fetchStationData();
        }else{
            setLoadStationNameTitle(false);
        }

        if (user.roles?.[0]) {
            fetchRolesData()
        }

    },[]);

    const fetchStationData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/v1/stations/${user.stations[0]}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch station data');
            }

            const data = await response.json();
            setStationName(data.name);
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
            setLoadStationNameTitle(false);
        }
    };

    const fetchRolesData = async () => {
        try {
            let response_role = null;
            let role_data = null

            response_role = await fetch(`${process.env.REACT_APP_API_URL}/v1/auth_roles/${user.roles?.[0]}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response_role.ok) {
                throw new Error('Failed to fetch role data');
            }

            role_data = await response_role.json();
            // //console.log(role_data.roles.name);
            setRoleName(role_data.roles.name)

        } catch (error) {
            setError(error.message);
        } finally {
            setLoadRoleNameTitle(false);
        }
    };


    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setLoadingImage(true);
        const fetchData = async () => {
            try {
                const fetch_image = await fetch(`${process.env.REACT_APP_API_URL}/v1${user.user_profile.image_profile}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                });


                if (fetch_image.status === 200) {
                    const blob = await fetch_image.blob();
                    const imageUrl = URL.createObjectURL(blob);
                    setImage(imageUrl)
                } else if (fetch_image.status === 403) {
                    // toast.error("Forbidden to fetch user profile picture. Please contact admin.");
                } else {
                    //toast.error("Unable to get user profile picture.");
                }
            } catch (error) {
                toast.error("Unable to fetch image from given api.");
            } finally {
                setLoadingImage(false);
            }
        };
        fetchData();
    }, [user]);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const isMobile = screenWidth < 768;

    function handleLogout(event) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
        navigate('/signin');
        setMenuOpen(!menuOpen);
    }
    function handleUpdateProfile(event) {
        setMenuOpen(!menuOpen);
        navigate('/profile');
    }
    const handleLanguageChange = (e) => {
        //console.log(e.target.value);
        i18n.changeLanguage(e.target.value);
    }

    return (
        <>
            <Toaster position="top-right" richColors />
            <header className="flex items-center justify-between p-2 bg-gray-800 text-white">

                <div className='flex items-center space-x-2'>

                    <button
                        className="text-white"
                        onClick={() => setNavigationSidebarOpen(!isNavigationSidebarOpen)}
                    >
                        <Bars4Icon className="h-6 w-6" />
                    </button>
                    {
                        <p>{loadStationNameTitle ? <ArrowPathIcon className="animate-spin h-5 w-5 text-gray-500" /> : stationName ? `${stationName} / ` : ''} {loadRoleNameTitle ? <ArrowPathIcon className="animate-spin h-5 w-5 text-gray-500" /> : roleName ? `${roleName}` : ''}</p>
                    }
                </div>
                <div className="flex space-x-5">
                    <select
                        className={`text-white bg-gray-800 py-2 focus:outline-none `}
                        value={i18n.language}
                        onChange={handleLanguageChange}
                    >
                        <option value="en">English</option>
                        <option value="am">Amharic</option>
                        <option value="ao">Afaan Oromo</option>
                    </select>
                    <button
                        className="flex items-center text-white space-x-4"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <p>{user.firstname + ' ' + user.lastname}</p>

                        {loadingImage
                            ?
                            <div className="flex items-center justify-center m-5">
                                <ArrowPathIcon className="animate-spin h-5 w-5 text-gray-500" />
                                <span className="ml-2 text-gray-500"></span>
                            </div>
                            :
                            <img className="w-14 h-14 rounded-full cursor-pointer" src={image ? image : "logo_transparent.png"} alt="Circle Image" />}
                    </button>
                </div>

                {menuOpen && (
                    <div
                        ref={menuRef}
                        className="absolute right-5 mt-44 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
                    >
                        <div role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <div className='px-4 py-2 text-white bg-cheche'>
                                <p className='font-bold text-center'>{loadRoleNameTitle ? 'Loading....' : roleName ? `${roleName}` : ''}</p>
                            </div>
                            <button
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
                                role="menuitem"
                                onClick={handleUpdateProfile}
                            >
                                <UserIcon className="h-6 w-6" />
                                <p>Update profile</p>
                            </button>
                            <button
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
                                role="menuitem"
                                onClick={handleLogout}
                            >
                                <ArrowLeftStartOnRectangleIcon className="h-6 w-6" />
                                <p>Logout</p>
                            </button>
                        </div>
                    </div>
                )}

            </header>
        </>
    );
}

export default Header;